export default __webpack_public_path__ + "static/media/kitchen1-1024w.623e3787.webp";